import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React, { useState } from 'react';

import { useBusiness } from '@/hooks/useBusiness';

import InputAutoComplete from '../InputAutoComplete/InputAutoComplete';
import InternetBanner from '../InternetBanner/InternetBanner';

import styles from './Banner.module.scss';

const MainBanner = ({ data, dark = false }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const [value, setValue] = useState('');
  const isBusiness = useBusiness();
  const handleSetValue = (value) => {
    router.push({
      pathname: `/${
        isBusiness ? 'business/business-roaming' : 'prices-and-countries'
      }`,
      query: {
        country: value,
      },
    });
  };
  return (
    <InternetBanner
      bannerData={data}
      dark={dark}
      size={data?.size}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.inputContainer}>
        <InputAutoComplete
          value={value}
          setValue={setValue}
          onSelect={handleSetValue}
          className={styles.input}
          data={data}
          placeholder={t('common:Enter Country')}
        />
      </div>
    </InternetBanner>
  );
};

export default MainBanner;
